import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const generateListItemClassNames = ({ sku, selectedSKU }) => (
  classNames(
    'product-swatch-descriptors__list-item',
    {
      'product-swatch-descriptors__list-item--active': sku === selectedSKU,
    },
  )
);

const generateLabelClassNames = ({ availableQuantity }) => (
  classNames(
    'product-swatch-descriptors__label',
    {
      'product-swatch-descriptors__label--out-of-stock': availableQuantity === 0,
    },
  )
);

const ProductSwatchDescriptors = ({
  swatches,
  selectedSKU,
  setProductSKU,
}) => (
  <ul className="product-swatch-descriptors flex-container">
    {
      swatches.map(({ sku, itemName, availableQuantity }) => (
        <li
          className={generateListItemClassNames({ sku, selectedSKU })}
          key={sku}
        >
          <input
            type="radio"
            id={sku}
            name="product-swatch-descriptors-selector"
            className="product-swatch-descriptors__input"
            checked={sku === selectedSKU}
            onChange={() => setProductSKU(sku)}
          />
          <label
            htmlFor={sku}
            className={generateLabelClassNames({ availableQuantity })}
          >
            {itemName}
          </label>
        </li>
      ))
    }
  </ul>
);

ProductSwatchDescriptors.propTypes = {
  swatches: PropTypes.arrayOf(PropTypes.shape({
    itemName: PropTypes.string,
    sku: PropTypes.string,
  })).isRequired,
  selectedSKU: PropTypes.string.isRequired,
  setProductSKU: PropTypes.func.isRequired,
};

export default ProductSwatchDescriptors;
